<template>
  <div class="custom-multiselect">
    <b-form-group :label="label" :label-cols="spacing" :horizontal="true">
      <multiselect :value="value" v-model="selected" @input="updateInput()" :options="options"
        :track-by="trackBy" :label="optionsLabel" :multiple="multiple" selectLabel="" :deselectLabel="allowEmpty ? 'Remove' : ''"
        :placeholder="placeholder" :disabled="disabled" :class="{invalid: invalid}" :allowEmpty="allowEmpty"></multiselect>
    </b-form-group>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'CustomDropdown',
  components: {
    Multiselect
  },
  data() {
    return {
      selected: null,
      initializedDependent: false,
      initializedOptions: false
    };
  },
  props: {
    value: [Object, Array],
    label: {
      type: String
    },
    spacing: {
      type: Number,
      default: 3
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cacheKey: {
      type: String,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array
    },
    trackBy: {
      type: String
    },
    optionsLabel: {
      type: String
    },
    placeholder: {
      type: String
    },
    dependent: {
      type: Object
    },
    allowEmpty: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateInput() {
      this.$emit('input', this.selected);

      if (this.cacheKey) {
        if (this.selected) {
          this.$store.dispatch('localstorage/saveToLocalStorage', { key: this.cacheKey, value: this.selected });
        } else {
          this.$store.dispatch('localstorage/removeFromLocalStorage', { key: this.cacheKey });
        }
      }
    },
    getFirstElement() {
      if (this.options.length === 0) return;

      this.selected = this.options[0];
      this.$emit('input', this.selected);
      this.$store.dispatch('localstorage/saveToLocalStorage', { key: this.cacheKey, value: this.selected });
    }
  },
  watch: {
    dependent() {
      this.selected = null;

      if (this.initializedDependent && this.cacheKey) {
        this.$store.dispatch('localstorage/removeFromLocalStorage', { key: this.cacheKey });
      }

      this.initializedDependent = true;

      this.$emit('input', this.selected);
    },
    value() {
      this.selected = this.value;
    },
    options: {
      immediate: true,
      handler(options) {
        if (options.length === 0) return;

        if (!this.initializedOptions && this.cacheKey) {
            this.initializedOptions = true;
            this.$store.dispatch('localstorage/getFromLocalStorage', { key: this.cacheKey })
              .then((data) => {
                if (data) {
                  if (!this.multiple) {
                    const found = options.find((val) => {
                      return val.id === data.id && val.name === data.name;
                    });

                    if (found) {
                      this.selected = data;
                      this.$emit('input', this.selected);
                    } else {
                      this.getFirstElement();
                    }
                  }

                  else {
                    let foundAll = true;
                    data.forEach((element, index) => {
                      const found = options.find((val) => {
                        return val.id === element.id && val.name === element.name;
                      });

                      if (!found) {
                        foundAll = false;
                      }
                    });

                    if (foundAll) {
                      this.selected = data;
                      this.$emit('input', this.selected);
                    } else {
                      this.getFirstElement();
                    }
                  }
                } else {
                  this.getFirstElement();
                }
              });
          } else {
            if (this.selected === null) {
              this.getFirstElement();
            }
          }
      }
    }
  }
};
</script>

<style scoped>
  .form-group {
    margin-bottom: 0.5rem;
  }
</style>
<style>
  .custom-multiselect .multiselect .multiselect__option--highlight {
    background: #FF9E1B
  }

  .custom-multiselect .multiselect .multiselect__option--selected.multiselect__option--highlight {
    background: #FF6A6A
  }

  .custom-multiselect .multiselect.invalid .multiselect__tags {
    border-color: #F86C6B
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
